module.exports = __webpack_public_path__ + "static/media/regular.0e9bd306.png";